// src/components/AscendantCalculator.jsx
import React, { useState } from 'react';
import zodiacData from '../data/zodiac-data.json';
import citiesData from '../data/cities-data.json';
import { calcularAscendente } from '../utils/ascendant';

const AscendantCalculator = ({ onViewFullSign }) => {
  const [birthDate, setBirthDate] = useState('');
  const [hour, setHour] = useState('12');
  const [minute, setMinute] = useState('0');
  const [cityIndex, setCityIndex] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);
    if (!birthDate || cityIndex === '') {
      setError('Completá la fecha, hora y ciudad de nacimiento.');
      return;
    }
    const [year, month, day] = birthDate.split('-').map(Number);
    const city = citiesData[Number(cityIndex)];
    const { signo, ascGrados } = calcularAscendente({
      year, month, day,
      hourLocal: Number(hour), minuteLocal: Number(minute),
      utcOffset: city.utcOffset, lat: city.lat, lon: city.lon,
    });
    const signData = zodiacData.signs.find((s) => s.name === signo);
    setResult({ signo, ascGrados, signData });
  };

  return (
    <div className="zodiac-tool-card">
      <h3 className="zodiac-section-title font-cinzel">Calculadora de Ascendente</h3>
      <p className="zodiac-tool-desc">
        El Ascendente se calcula con fecha, hora exacta y lugar de nacimiento — cálculo astronómico real (fórmulas de Jean Meeus). Elegí la ciudad más cercana a donde naciste.
      </p>
      <form className="zodiac-tool-form zodiac-ascendant-form" onSubmit={handleSubmit}>
        <input
          type="date"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
          required
          className="guide-search-input"
        />
        <div className="zodiac-time-inputs">
          <select value={hour} onChange={(e) => setHour(e.target.value)} className="guide-search-input zodiac-select-small" aria-label="Hora de nacimiento">
            {Array.from({ length: 24 }, (_, i) => (
              <option key={i} value={i}>{String(i).padStart(2, '0')}h</option>
            ))}
          </select>
          <select value={minute} onChange={(e) => setMinute(e.target.value)} className="guide-search-input zodiac-select-small" aria-label="Minuto de nacimiento">
            {[0, 15, 30, 45].map((m) => (
              <option key={m} value={m}>{String(m).padStart(2, '0')}m</option>
            ))}
          </select>
        </div>
        <select
          value={cityIndex}
          onChange={(e) => setCityIndex(e.target.value)}
          required
          className="guide-search-input"
        >
          <option value="">Ciudad de nacimiento...</option>
          {citiesData.map((c, i) => (
            <option key={c.name} value={i}>{c.name}</option>
          ))}
        </select>
        <button type="submit" className="main-button primary-button">Calcular Ascendente</button>
      </form>

      {error && <p className="zodiac-horoscope-error">{error}</p>}

      {result && (
        <div className="zodiac-tool-result">
          <div className="zodiac-tool-result-header">
            <span className="zodiac-tool-result-symbol">{result.signData.symbol}</span>
            <div>
              <h4 className="font-cinzel">Ascendente en {result.signo}</h4>
              <p className="zodiac-card-element">{result.ascGrados.toFixed(1)}° dentro del signo</p>
            </div>
          </div>
          <p className="zodiac-tool-result-desc">{result.signData.description}</p>
          <button className="main-button secondary-button" onClick={() => onViewFullSign(result.signData)}>
            Ver ficha completa
          </button>
          <p className="zodiac-ascendant-note">
            📏 Cálculo aproximado (±2' de arco) usando la coordenada de referencia de la ciudad elegida y hora estándar sin horario de verano. Para máxima precisión, usá tu hora y lugar de nacimiento exactos.
          </p>
        </div>
      )}
    </div>
  );
};

export default AscendantCalculator;
